import { useLayoutEffect, useState, useCallback } from 'react';

export const useBoundingClientRect = (ref) => {
  const { current: refToDomElement } = ref || {};
  const [value, setValue] = useState(null);

  const update = useCallback(() => {
    setValue(refToDomElement ? getBoundingClientRect(refToDomElement) : null);
  }, [refToDomElement]);

  useLayoutEffect(() => {
    if (!refToDomElement) {
      return;
    }
    update();
    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('resize', update);
    };
  }, [update, refToDomElement]);

  return value;
};

export const getBoundingClientRect = (element) => {
  const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect();

  return {
    top,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y,
    absoluteTop: top + window?.scrollY,
    absoluteBottom: bottom + window?.scrollY,
    absoluteLeft: left + window?.scrollX,
    absoluteRight: right + window?.scrollX,
  };
};
